import {MdFileUpload, MdNotes, MdOutlineNoteAdd} from "react-icons/md";
import React, {useState} from "react";
import Card from "components/card";
import InputField from "components/fields/InputField2";
import {useDropzone} from "react-dropzone";
import {useUserAuth} from "../../../../../context/UserAuthContext";
import {AES, enc} from "crypto-js";
import {useNavigate, useParams} from "react-router-dom";
import axios from "axios";
import binFileImage from '../../../../../assets/img/others/BinFileImage.jpeg'
import {Spinner} from "@chakra-ui/react";
import { MdNoteAlt } from "react-icons/md";
import { MdSendToMobile } from "react-icons/md";
import NotifyUsersModal from 'components/notifications/NotifyUsersModal'
import { toast } from "react-toastify";

const FirmwareUploadFile = () => {

    const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    const REACT_APP_CROMPTON_SENZE_ORIGIN_URL = process.env.REACT_APP_CROMPTON_SENZE_ORIGIN_URL;
    const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

    //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
    //const CROMPTON_ANALYTICS_URL = "https://iot.crompton.co.in:8443/AAPI/"
    const secretKey = "cromptonssecretkey";

    let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
    const decryptedValueuname = AES.decrypt(Username, secretKey).toString(enc.Utf8);
    const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);
    const navigate = useNavigate();
    const params = useParams();

    let [selectedFile, setSelectedFile] = useState("");
    let [version, setVersion] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setIsLoading] = useState(false);

    const [showReleaseNotes, setShowReleaseNotes] = useState(false);
    const [releaseNotes, setReleaseNotes] = useState("");

    const [isNotifyModalOpen, setIsNotifyModalOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [notificationVersion, setNotificationVersion] = useState("");

    const handleLogOut = async () => {
        try {
            await logOut();
            navigate("/");
        } catch (error) {
            ////console.log(error.message);
        }
    }

    const handleSearchSubmit = async () => {
        if (!searchQuery.trim()) return;

        const url = CROMPTON_URL + "user/getByMobile/" + searchQuery;

        await axios({
            method: "GET",
            url: url,
            headers: {
                Authorization: decryptedValue,
            }
        }).then((res) => {
            if (res.data) {
                setFilteredUsers([res.data]);
            } else {
                setFilteredUsers([]);
            }
        }).catch((error) => {
            setErrorMessage(error.response?.data?.message || "Failed to fetch user");
            setFilteredUsers([]);
            if (
                error.response?.data?.status === "401" ||
                error.response?.data?.status === "403"
            ) {
                handleLogOut();
            }
        });
    };

    function getProductName(productId) {
        const productCatalog = JSON.parse(sessionStorage.getItem("productCatalogArray")) || [];

        const matchedProduct = productCatalog.find(
            (item) => item.productId === productId
        );

        return matchedProduct ? matchedProduct.product : "";
    }

    const handleNotifySelected = async () => {
        try {
            const usernames = selectedUsers.map((user) => user.username);

            const response = await axios.post(
                CROMPTON_URL + "notifications/ads/sendSpecific",
                {
                    title: "New Firmware Version: " + notificationVersion + " Released for " + getProductName(params.id) ,
                    description: releaseNotes,
                    buttonText: "Update",
                    buttonUrl: "",
                    expiryDate: "",
                    imageUrl: "",
                    usernames: usernames,
                   /* firmwareId: params.id,
                    version,
                    releaseNotes,
                    usernames,*/
                },
                {
                    headers: {
                        Authorization: decryptedValue,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.status === 200) {
                toast.success(response.data.message || "Notification sent successfully");
                setIsNotifyModalOpen(false);
                setSelectedUsers([]);
            } else {
                //console.log(response);
                toast.error("Failed to send notification");
            }
        } catch (error) {
            //console.log(error);
            toast.error(error.response?.data?.message || "Failed to send notification");
        }
    };

    const handleNotifyAll = async () => {
        try {
            const response = await axios.post(
                CROMPTON_URL + "notifications/ads/sendAll",
                {
                    title: "New Firmware Version: " + notificationVersion + " Released for " + getProductName(params.id) ,
                    description: releaseNotes,
                    buttonText: "Update",
                    buttonUrl: "",
                    expiryDate: "",
                    imageUrl: "",
                },
                {
                    headers: {
                        Authorization: decryptedValue,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.status === 200) {
                toast.success(response.data.message || "Notification sent successfully");
                setIsNotifyModalOpen(false);
                setSelectedUsers([]);
            } else {
                toast.error("Failed to send notification");
            }
        } catch (error) {
            toast.error(error.response?.data?.message || "Failed to send notification");
        }
    };


    const onDrop = async acceptedFiles => {
        //console.log("Inside")
        setIsLoading(true)
        if (acceptedFiles.length > 0) {
            const file = acceptedFiles[0];
            //console.log("Inside")
            //console.log(file.type)

            // Check for valid image types (optional)
            const validImageTypes = ['application/octet-stream'];
            if (!validImageTypes.includes(file.type)) {
                setIsLoading(false)
                //console.error('Invalid image type. Please upload a JPEG or PNG file.');
                setErrorMessage('Invalid image type. Please upload a JPEG or PNG file.')
                return;
            }

            // Check for size limit (optional)
            if (file.size > 1048576*2) {  // 1 MB
                setIsLoading(false)
                setErrorMessage('Image size exceeds 2 MB limit.')
                //console.error('Image size exceeds 1 MB limit.');
                return;
            }

            setErrorMessage("")
            const reader = new FileReader();
            reader.readAsDataURL(file); // Read image as data URL
            setSelectedFile(file)
            selectedFile = file
            setIsLoading(false)
        }
    };

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept: { "application/bin": [".bin"] }, // Strictly allow .bin files
        maxFiles: 1, // Optional: Limit the number of files
    });

    const uploadBinaryFile = async () => {
        if (selectedFile === "" || selectedFile === null || selectedFile.type === "" || selectedFile.type === null) {
            setErrorMessage("Please upload a valid binary file")
        } else if (version === "" || version === null) {
            setErrorMessage("Please enter a valid version number")
        } else {
            const bodyFormData = new FormData();
            const blob = new Blob([selectedFile], {type: selectedFile.type});
            bodyFormData.append("fileImage", blob);
            bodyFormData.append(
                "firmwareReleaseInfo",
                new Blob([JSON.stringify({ releaseNotes })], { type: "application/json" })
            );
            //bodyFormData.append("firmwareReleaseInfo", new Blob([JSON.stringify(releaseNotes)], { type: "application/json" }));
            //console.log(bodyFormData.fileImage)
            //console.log(pid)
            const url = REACT_APP_CROMPTON_SENZE_ORIGIN_URL + "device/firmware/upload/" + params.id + "/" + version;
            await axios.post(url, bodyFormData, {

                headers: {
                    "Content-Type": "multipart/form-data",

                    Authorization: decryptedValue
                },
            }).then((response) => {
                setErrorMessage("Binary uploaded successfully")
                window.location.reload()
                //console.log(response)


            }).catch((error) => {

                setErrorMessage(error.response.data.message)
                //console.log(error);
                if (error.response.data.status === "401" || error.response.data.status === "403") {
                    handleLogOut();
                }
            })
        }

    }

    const handleVersionChange = (newValue) => {
        setVersion(newValue); // Update state with the new value
        version = newValue
    };

    return (
        <div>
            <div>
                <Card
                    className="grid h-full w-full grid-cols-1 gap-3 rounded-[20px] bg-white bg-clip-border p-3 font-dm shadow-3xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none 2xl:grid-cols-11">
                    {
                        !loading &&
                        <div
                            className="col-span-5 h-full w-full rounded-xl bg-lightPrimary dark:!bg-navy-700 2xl:col-span-6"
                            {...getRootProps()}>
                            {
                                !selectedFile && (
                                    <button
                                        className="flex h-full w-full flex-col items-center justify-center rounded-xl border-[2px]
                        border-dashed border-gray-200 py-3 dark:!border-navy-700 lg:pb-0">
                                        <input {...getInputProps()} />
                                        <MdFileUpload className="text-[80px] text-[#004c86] dark:text-white"/>
                                        <h4 className="text-xl font-bold text-[#004c86] dark:text-white">
                                            Upload Files
                                        </h4>
                                        <p className="mt-2 text-sm font-medium text-gray-600">
                                            BIN files are allowed
                                        </p>
                                    </button>
                                )
                            }
                            {
                                selectedFile && (
                                    <div
                                        className="h-full !w-full items-center flex justify-content: center align-items: center flex-col">
                                        <img id="productImage" src={binFileImage}
                                             className="flex h-[225px] w-full flex-col items-center justify-center
                           rounded-xl border-[1px] border-dashed border-gray-200
                            bg-gray-100 dark:!border-none dark:!bg-navy-700 sm:w-[400px] md:w-[570px]
                            lg:w-fit xl:w-fit 2xl:w-fit 3xl:w-fit"
                                             alt="Uploaded preview"/>
                                        {selectedFile && (
                                            <p className="text-sm text-gray-600 mt-2">
                                        <span className="font-bold">
                                            Uploaded file:&nbsp;
                                        </span>
                                                <span className="font-semibold text-[#004c86]">
                                            {selectedFile.name}
                                        </span>
                                            </p>
                                        )}
                                        <p className="text-sm text-gray-600 mt-2">
                                        <span className="font-bold">
                                            File Size: &nbsp;
                                        </span>
                                            <span className="font-semibold text-[#004c86]">
                                            {selectedFile.size} B
                                        </span>
                                        </p>
                                        <p className="pt-2 text-sm text-gray-600">
                                            {""}
                                        </p>
                                        <p className="pt-2 text-sm font-bold text-[#0b83b5] cursor-pointer">
                                            Click here to upload again
                                            <input {...getInputProps()}  />
                                        </p>
                                    </div>
                                )
                            }
                        </div>

                    }
                    {
                        loading &&
                        <div
                            className="col-span-5 h-full w-full rounded-xl bg-lightPrimary dark:!bg-navy-700 2xl:col-span-6"
                            style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                            <Spinner
                                size="xl" // Set a larger size (adjust as needed)
                                thickness="15px" // Increase thickness for better visibility (optional)
                            />
                        </div>

                    }
                    <div
                        className="items-start justify-between col-span-5 flex h-full w-full flex-col overflow-hidden rounded-xl bg-white pl-3 pb-4 dark:!bg-navy-800"
                    >
                        {/* Wrap heading and icon together */}
                        <div className="flex w-full items-center justify-between">
                            <h4 className="text-lg font-bold leading-9 text-navy-700 dark:text-white">
                                Upload New Version
                            </h4>
                            <button
                                onClick={() => setShowReleaseNotes(true)}
                                className="text-[#004c86] hover:text-[#006fbf] dark:text-white"
                                title="Add Release Notes"
                            >
                                <MdOutlineNoteAdd className="text-2xl" />
                            </button>
                        </div>

                        <p className="leading-1 mt-2 text-base font-normal text-gray-600">
                            You can deploy firmware updates over the air (OTA) without flashing firmware.
                        </p>
                        <br />

                        <InputField
                            variant="auth"
                            extra="mb-3"
                            label="Firmware Version*"
                            placeholder="Enter Firmware Version"
                            id="email"
                            type="text"
                            onChange={handleVersionChange} // Pass the function as prop
                        />

                        {/*<button
                            className="mt-4 flex items-center justify-center rounded-xl bg-[#004c86] px-2 py-2 text-base
                            font-medium text-white transition duration-200 hover:bg-[#004c86] active:bg-[#004c86]
                            dark:bg-[#004c86] dark:text-white dark:hover:bg-[#004c86] dark:active:bg-[#004c86]"
                            onClick={uploadBinaryFile}>
                            Upload
                        </button>*/}

                        <div className="flex gap-3 mt-4">
                            <button
                                className="flex items-center justify-center rounded-xl bg-[#004c86] px-4 py-2 text-base font-medium text-white transition duration-200 hover:bg-[#004c86]"
                                onClick={uploadBinaryFile}
                            >
                                Upload
                            </button>

                            <button
                                className="flex items-center justify-center rounded-xl bg-[#0b83b5] px-4 py-2 text-base font-medium text-white transition duration-200 hover:bg-[#09739c]"
                                onClick={() => {
                                    setNotificationVersion(version || "");
                                    setIsNotifyModalOpen(true);
                                }}
                            >
                                <MdSendToMobile className="mr-2 text-xl" />
                                Notify Users
                            </button>
                        </div>

                        <NotifyUsersModal
                            isOpen={isNotifyModalOpen}
                            onClose={() => {
                                setIsNotifyModalOpen(false);
                                setSelectedUsers([]);
                                setFilteredUsers([]);
                                setSearchQuery("");
                            }}
                            onSearchSubmit={handleSearchSubmit}
                            filteredUsers={filteredUsers}
                            selectedUsers={selectedUsers}
                            setSelectedUsers={setSelectedUsers}
                            onNotifySelected={handleNotifySelected}
                            onNotifyAll={handleNotifyAll}
                            searchQuery={searchQuery}
                            setSearchQuery={setSearchQuery}
                            modalTitle="Notify Users About Firmware"
                            showVersionField={true}
                            selectedVersion={notificationVersion}
                            setSelectedVersion={setNotificationVersion}
                        />
                    </div>
                </Card>
            </div>
            <div>
                <span
                    className="errorMessage items-center flex justify-content: center align-items: center flex-col">
                    {errorMessage}
                </span>
            </div>
            {showReleaseNotes && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="w-[90%] max-w-md rounded-lg bg-white p-6 shadow-lg dark:bg-navy-700">
                        <h2 className="text-xl font-bold text-navy-700 dark:text-white mb-4">
                            Release Notes
                        </h2>
                        <textarea
                            className="w-full h-40 p-3 text-sm border rounded-md focus:outline-none focus:ring-2 focus:ring-[#004c86] dark:bg-navy-800 dark:text-white"
                            value={releaseNotes}
                            placeholder="Enter release notes here..."
                            onChange={(e) => setReleaseNotes(e.target.value)}
                        />
                        <div className="mt-4 flex justify-end space-x-2">
                            <button
                                className="px-4 py-2 text-sm rounded-md bg-gray-300 hover:bg-gray-400 dark:bg-gray-600 dark:text-white"
                                onClick={() => setShowReleaseNotes(false)}
                            >
                                Cancel
                            </button>
                            <button
                                className="px-4 py-2 text-sm rounded-md bg-[#004c86] text-white hover:bg-[#006fbf]"
                                onClick={() => {
                                    setShowReleaseNotes(false);
                                    // Optionally handle saving the release notes
                                }}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            )}


        </div>


    );
};

export default FirmwareUploadFile;
